import { Stack, Typography } from "@mui/material";
import { Children, FC, ReactNode } from "react";

interface ICPChartsSectionProps {
  /** Title for the charts section (e.g., "Industry") */
  title: string;
  /** Chart components to display */
  children: ReactNode;
}

/**
 * Component that displays a title and a box with charts
 * Uses flex column layout with gap between charts
 * Only shows title when there's more than one chart
 */
export const ICPChartsSection: FC<ICPChartsSectionProps> = ({
  title,
  children,
}) => {
  const childCount = Children.count(children);

  return (
    <Stack gap={3} flex={1}>
      <Typography
        variant="h6"
        sx={{
          fontSize: "20px",
          fontWeight: "bold",
          color: "#3a3a3a",
          display: childCount > 1 ? "block" : "none",
        }}
      >
        {title}
      </Typography>
      <Stack spacing={3}>{children}</Stack>
    </Stack>
  );
};
